import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CTANavigation from '../../containers/cta-navigation';
import Cta from '../../containers/cta';

const CTANavigationBlock = props => <CTANavigation {...props} />;
CTANavigationBlock.displayName = 'CTANavigation';

export default withDynamicComponents({
  componentWhitelist: [
    Cta
  ],
  mapInputToOutput: [
    
  ],
})(CTANavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/cta-navigation/index.jsx